import { render, staticRenderFns } from "./OverviewHeaderMenu.vue?vue&type=template&id=0820b580&scoped=true&"
import script from "./OverviewHeaderMenu.vue?vue&type=script&lang=js&"
export * from "./OverviewHeaderMenu.vue?vue&type=script&lang=js&"
import style0 from "./OverviewHeaderMenu.vue?vue&type=style&index=0&id=0820b580&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0820b580",
  null
  
)

export default component.exports